import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Organization, Language } from '../../models';
import { OrganizationDataService, UserDataService, LanguageDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { UserForm } from './UserForm';
import { PVAPage } from '..';
import { UserStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';

interface UserCreateState {
    organizations: Organization[];
    languages: Language[];
    previousOrganizationId: number;
}

interface UserCreateProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
}

@inject('UserStore') @observer
export class UserCreate extends React.Component<UserCreateProps, UserCreateState> {
    private organizationDataService = new OrganizationDataService(this.props.notificationService);
    private languageDataService = new LanguageDataService(this.props.notificationService);
    private userDataService = new UserDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get organization() {
        return this.props.UserStore!.userInfo.organization;
    }

    constructor(props: UserCreateProps) {
        super(props);

        this.state = {
            organizations: new Array<Organization>(),
            languages: new Array<Language>(),
            previousOrganizationId: 0
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        if (this.props.UserStore!.userRoleIn([Roles.OrgAdmin, Roles.Manager, Roles.User])) {
            this.organizationDataService.get(this.organization!.id).then((organization: Organization) => {
                this.setState({ organizations: [organization] });
            });
        } else {
            this.organizationDataService.getAll().then((organizations: Organization[]) => {
                this.setState({ organizations: organizations });
            });
        }

        this.languageDataService.getAll().then((languages: Language[]) => {
            this.setState({ languages: languages });
        });
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            <NavLink to={`/user`}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            <span>Create User</span>
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    {this.state.organizations.length > 0 && this.state.languages.length > 0 && <UserForm submit={this.save} {...this.state} defaultValues={{}} notificationService={this.props.notificationService} />}
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.userDataService.create(values)
            .then((success) => {
                this.props.history.push('/user');
            })
            .catch(() => {
                this.props.notificationService.addError('Please address validation messages and try again.');
            });
    }
}


// WEBPACK FOOTER //
// ./src/components/user/UserCreate.tsx